import { Headline } from "components/typography";
import React from "react";

import styled from "@emotion/styled";
import { Dialog, DialogContent } from "@mui/material";

const ModalHeadLine = styled(Headline)`
  margin-bottom: 0;
  color: #10265f;
`;

export const Modal = ({ isOpen, onClose, title, children }: ModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      {title && <ModalHeadLine>{title}</ModalHeadLine>}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

interface ModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly title?: React.ReactNode;
  readonly children: React.ReactNode;
}
